export enum KycFlow {
    DOCVAULT = "docvault",
    UNIBO = "unibo",
}

export const DEFAULT_KYC_FLOW = KycFlow.DOCVAULT;

export const KYC_FLOW_BASE_PATHS: Record<KycFlow, string> = {
    [KycFlow.DOCVAULT]: "/doc-vault",
    [KycFlow.UNIBO]: "/unibo",
};
